import { createNavigationContainerRef } from "@react-navigation/native";
import { AuthStackParamList } from "./navigationTypes";

export const navigationRef = createNavigationContainerRef<AuthStackParamList>();
